export const RhodeIsland = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 45 72"
      fill="none"
      className={props.className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.2962 0H0V24V48H22.2962V72H44.5924V48V24H22.2962V0Z"
        fill={props.fill}
      />
    </svg>
  );
};

export const SoftStar = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 90 90"
      fill="none"
      className={props.className}
    >
      <path
        d="M43.7991 1.06678C43.968 -0.355592 46.032 -0.355592 46.2009 1.06678L47.6167 12.9992C49.4449 28.4071 61.5929 40.5551 77.0007 42.3833L88.9331 43.7991C90.3556 43.968 90.3556 46.032 88.9331 46.2009L77.0007 47.6167C61.5929 49.4449 49.4449 61.5929 47.6167 77.0007L46.2009 88.9331C46.032 90.3556 43.968 90.3556 43.7991 88.9331L42.3833 77.0007C40.5551 61.5929 28.4071 49.4449 12.9992 47.6167L1.06678 46.2009C-0.355592 46.032 -0.355592 43.968 1.06678 43.7991L12.9992 42.3833C28.4071 40.5551 40.5551 28.4071 42.3833 12.9992L43.7991 1.06678Z"
        fill={props.fill}
      />
    </svg>
  );
};

export const Lightning = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 65 115"
      fill="none"
      className={props.className}
    >
      <path
        d="M50.6818 0L0 64.5455H23.3786L14.3182 115L65 50.4545H41.6214L50.6818 0Z"
        fill={props.fill}
      />
    </svg>
  );
};

export const DecorLines = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 150 82"
      fill="none"
      className={props.className}
    >
      <path
        d="M91.1441 81.4536L146.977 0L129.362 0.450355L76.0457 81.8396L91.1441 81.4536Z"
        fill={props.fill}
      />
      <path
        d="M54.1568 81.4536L109.99 0L92.3749 0.450355L39.0583 81.8396L54.1568 81.4536Z"
        fill={props.fill}
      />
      <path
        d="M17.1432 81.4536L72.9762 0L55.3612 0.450355L2.04468 81.8396L17.1432 81.4536Z"
        fill={props.fill}
      />
    </svg>
  );
};

export const SemiCircleYellow = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 131 266"
      fill="none"
      className={props.className}
    >
      <g opacity="1" clipPath="url(#clip0_22_70)">
        <path
          d="M130.5 0L130.5 266C21.6506 251.153 -1.43871 169.085 0.622845 129.907C0.622845 30.93 87.2076 2.06201 130.5 0Z"
          fill={props.fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_22_70">
          <rect
            width="266"
            height="131"
            fill="white"
            transform="matrix(0 -1 1 0 0 266)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const MonitorIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 50 50"
      fill="none"
      className={props.className}
    >
      <path
        opacity="0.6"
        d="M45.7709 13.3542V26.8959H4.16675V13.3542C4.16675 8.29169 8.29175 4.16669 13.3542 4.16669H36.5834C41.6459 4.16669 45.7709 8.29169 45.7709 13.3542Z"
        fill={props.fillLight}
      />
      <path
        d="M4.16675 26.9167V27.3334C4.16675 32.4167 8.29175 36.5209 13.3542 36.5209H21.3542C22.5001 36.5209 23.4376 37.4584 23.4376 38.6042V40.625C23.4376 41.7709 22.5001 42.7084 21.3542 42.7084H16.3126C15.4584 42.7084 14.7501 43.4167 14.7501 44.2709C14.7501 45.125 15.4376 45.8334 16.3126 45.8334H33.7084C34.5626 45.8334 35.2709 45.125 35.2709 44.2709C35.2709 43.4167 34.5626 42.7084 33.7084 42.7084H28.6667C27.5209 42.7084 26.5834 41.7709 26.5834 40.625V38.6042C26.5834 37.4584 27.5209 36.5209 28.6667 36.5209H36.6042C41.6876 36.5209 45.7917 32.3959 45.7917 27.3334V26.9167H4.16675Z"
        fill={props.fill}
      />
    </svg>
  );
};

export const DashMonitorIcon = (props) => {
  return (
    <svg width={props.width}
      height={props.height}
      className={props.className}
      viewBox="0 0 44 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 38H30M22 30V38M6 2H38C40.2091 2 42 3.79086 42 6V26C42 28.2091 40.2091 30 38 30H6C3.79086 30 2 28.2091 2 26V6C2 3.79086 3.79086 2 6 2Z"
        fill={props.fillLight} 
        stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  );
};

export const EditIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 50 50"
      fill="none"
      className={props.className}
    >
      <path
        opacity="0.6"
        d="M32.2501 6.25H15.6667C8.47925 6.25 4.16675 10.5417 4.16675 17.75V34.3125C4.16675 41.5417 8.47925 45.8333 15.6667 45.8333H32.2292C39.4376 45.8333 43.7293 41.5417 43.7293 34.3333V17.75C43.7501 10.5417 39.4376 6.25 32.2501 6.25Z"
        fill={props.fillLight}
      />
      <path
        d="M43.7916 6.20834C40.0624 2.45834 36.4166 2.375 32.5832 6.20834L30.2291 8.54167C30.0207 8.75 29.9582 9.04167 30.0416 9.3125C31.4999 14.4167 35.5832 18.5 40.6874 19.9583C40.7499 19.9792 40.8541 19.9792 40.9166 19.9792C41.1249 19.9792 41.3332 19.8958 41.4791 19.75L43.7916 17.4167C45.6874 15.5208 46.6249 13.7083 46.6249 11.8542C46.6249 9.97917 45.6874 8.125 43.7916 6.20834Z"
        fill={props.fill}
      />
      <path
        d="M37.2082 21.7083C36.6457 21.4375 36.1041 21.1667 35.6041 20.8542C35.1874 20.6042 34.7707 20.3333 34.3749 20.0417C34.0416 19.8333 33.6665 19.5208 33.2915 19.2083C33.2499 19.1875 33.1249 19.0833 32.9582 18.9167C32.3124 18.3958 31.6249 17.6875 30.9791 16.9167C30.9374 16.875 30.8124 16.75 30.7082 16.5625C30.4999 16.3333 30.1874 15.9375 29.9166 15.5C29.6874 15.2083 29.4166 14.7917 29.1666 14.3542C28.8541 13.8333 28.5832 13.3125 28.3332 12.7708C28.0624 12.1875 27.8541 11.6458 27.6666 11.125L16.4582 22.3333C15.7291 23.0625 15.0207 24.4375 14.8749 25.4583L13.9791 31.6667C13.7916 32.9792 14.1457 34.2083 14.9582 35.0208C15.6457 35.7083 16.5832 36.0625 17.6249 36.0625C17.8541 36.0625 18.0832 36.0417 18.3124 36.0208L24.4999 35.1458C25.5207 35 26.8957 34.3125 27.6249 33.5625L38.8332 22.3542C38.3124 22.1875 37.7916 21.9583 37.2082 21.7083Z"
        fill={props.fill}
      />
    </svg>
  );
};

export const ConnectIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 50 50"
      fill="none"
      className={props.className}
    >
      <path
        opacity="0.6"
        d="M21.8751 33.3334H28.1251C33.3334 33.3334 36.4584 29.5834 36.4584 25V14.3959C36.4584 12.2084 34.6667 10.4167 32.4792 10.4167H17.5418C15.3543 10.4167 13.5626 12.2084 13.5626 14.3959V25C13.5418 29.5834 16.6667 33.3334 21.8751 33.3334Z"
        fill={props.fillLight}
      />
      <path
        d="M21.3542 4.16669V10.4167H18.2292V4.16669C18.2292 3.31252 18.9376 2.60419 19.7917 2.60419C20.6459 2.60419 21.3542 3.31252 21.3542 4.16669Z"
        fill={props.fill}
      />
      <path
        d="M31.7708 4.16669V10.4167H28.6458V4.16669C28.6458 3.31252 29.3541 2.60419 30.2083 2.60419C31.0624 2.60419 31.7708 3.31252 31.7708 4.16669Z"
        fill={props.fill}
      />
      <path
        d="M26.5625 33.3333V45.8333C26.5625 46.6875 25.8542 47.3958 25 47.3958C24.1458 47.3958 23.4375 46.6875 23.4375 45.8333V33.3333H26.5625Z"
        fill={props.fill}
      />
    </svg>
  );
};

export const LockIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 50 50"
      fill="none"
      className={props.className}
    >
      <path
        d="M25 36.1459C26.8754 36.1459 28.3958 34.6255 28.3958 32.75C28.3958 30.8746 26.8754 29.3542 25 29.3542C23.1245 29.3542 21.6041 30.8746 21.6041 32.75C21.6041 34.6255 23.1245 36.1459 25 36.1459Z"
        fill={props.fill}
      />
      <path
        opacity="0.6"
        d="M34.6875 19.6667H15.3125C6.77079 19.6667 4.16663 22.2709 4.16663 30.8125V34.6875C4.16663 43.2292 6.77079 45.8334 15.3125 45.8334H34.6875C43.2291 45.8334 45.8333 43.2292 45.8333 34.6875V30.8125C45.8333 22.2709 43.2291 19.6667 34.6875 19.6667ZM25 39.0417C21.5208 39.0417 18.7083 36.2084 18.7083 32.75C18.7083 29.2917 21.5208 26.4584 25 26.4584C28.4791 26.4584 31.2916 29.2917 31.2916 32.75C31.2916 36.2084 28.4791 39.0417 25 39.0417Z"
        fill={props.fillLight}
      />
      <path
        d="M14.8333 19.6875V17.25C14.8333 11.1459 16.5625 7.08335 25 7.08335C33.4375 7.08335 35.1666 11.1459 35.1666 17.25V19.6875C36.2291 19.7084 37.1875 19.75 38.0833 19.875V17.25C38.0833 11.625 36.7291 4.16669 25 4.16669C13.2708 4.16669 11.9166 11.625 11.9166 17.25V19.8542C12.7916 19.75 13.7708 19.6875 14.8333 19.6875Z"
        fill={props.fill}
      />
    </svg>
  );
};

export const SemiCircleLightBlue = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 49 100"
      fill="none"
      className={props.className}
    >
      <path
        d="M-0.000110626 100L-0.000110626 0C40.9207 5.58139 49.6009 36.4341 48.8259 51.1628C48.8259 88.3722 16.2752 99.2248 -0.000110626 100Z"
        fill={props.fill}
      />
    </svg>
  );
};

export const ElementPlusIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 24 24"
      fill="none"
      className={props.className}
    >
      <path
        d="M20.5 16.75H18.25V14.5C18.25 14.09 17.91 13.75 17.5 13.75C17.09 13.75 16.75 14.09 16.75 14.5V16.75H14.5C14.09 16.75 13.75 17.09 13.75 17.5C13.75 17.91 14.09 18.25 14.5 18.25H16.75V20.5C16.75 20.91 17.09 21.25 17.5 21.25C17.91 21.25 18.25 20.91 18.25 20.5V18.25H20.5C20.91 18.25 21.25 17.91 21.25 17.5C21.25 17.09 20.91 16.75 20.5 16.75Z"
        fill={props.fill}
      />
      <path
        opacity="0.4"
        d="M22 8.52V3.98C22 2.57 21.36 2 19.77 2H15.73C14.14 2 13.5 2.57 13.5 3.98V8.51C13.5 9.93 14.14 10.49 15.73 10.49H19.77C21.36 10.5 22 9.93 22 8.52Z"
        fill={props.fill}
      />
      <path
        d="M10.5 8.52V3.98C10.5 2.57 9.86 2 8.27 2H4.23C2.64 2 2 2.57 2 3.98V8.51C2 9.93 2.64 10.49 4.23 10.49H8.27C9.86 10.5 10.5 9.93 10.5 8.52Z"
        fill={props.fill}
      />
      <path
        opacity="0.4"
        d="M10.5 19.77V15.73C10.5 14.14 9.86 13.5 8.27 13.5H4.23C2.64 13.5 2 14.14 2 15.73V19.77C2 21.36 2.64 22 4.23 22H8.27C9.86 22 10.5 21.36 10.5 19.77Z"
        fill={props.fill}
      />
    </svg>
  );
};

export const CalendarIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 24 24"
      fill="none"
      className={props.className}
    >
      <path
        d="M16.75 3.56V2C16.75 1.59 16.41 1.25 16 1.25C15.59 1.25 15.25 1.59 15.25 2V3.5H8.74998V2C8.74998 1.59 8.40998 1.25 7.99998 1.25C7.58998 1.25 7.24998 1.59 7.24998 2V3.56C4.54998 3.81 3.23999 5.42 3.03999 7.81C3.01999 8.1 3.25999 8.34 3.53999 8.34H20.46C20.75 8.34 20.99 8.09 20.96 7.81C20.76 5.42 19.45 3.81 16.75 3.56Z"
        fill={props.fill}
      />
      <path
        opacity="0.4"
        d="M20 9.84C20.55 9.84 21 10.29 21 10.84V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V10.84C3 10.29 3.45 9.84 4 9.84H20Z"
        fill={props.fill}
      />
      <path
        d="M14.8399 14.99L14.3399 15.5H14.3299L11.2999 18.53C11.1699 18.66 10.8999 18.8 10.7099 18.82L9.35993 19.02C8.86993 19.09 8.52995 18.74 8.59995 18.26L8.78996 16.9C8.81996 16.71 8.94993 16.45 9.07993 16.31L12.1199 13.28L12.6199 12.77C12.9499 12.44 13.3199 12.2 13.7199 12.2C14.0599 12.2 14.4299 12.36 14.8399 12.77C15.7399 13.67 15.4499 14.38 14.8399 14.99Z"
        fill={props.fill}
      />
    </svg>
  );
};

export const HeadphoneIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 24 24"
      fill="none"
      className={props.className}
    >
      <path
        opacity="0.4"
        d="M2.75006 18.65C2.34006 18.65 2.00006 18.31 2.00006 17.9V12.2C1.95006 9.49 2.96006 6.93 4.84006 5.01C6.72006 3.1 9.24006 2.05 11.9501 2.05C17.4901 2.05 22.0001 6.56 22.0001 12.1V17.8C22.0001 18.21 21.6601 18.55 21.2501 18.55C20.8401 18.55 20.5001 18.21 20.5001 17.8V12.1C20.5001 7.39 16.6701 3.55 11.9501 3.55C9.64006 3.55 7.50006 4.44 5.91006 6.06C4.31006 7.69 3.46006 9.86 3.50006 12.18V17.89C3.50006 18.31 3.17006 18.65 2.75006 18.65Z"
        fill={props.fill}
      />
      <path
        d="M5.94 12.45H5.81C3.71 12.45 2 14.16 2 16.26V18.14C2 20.24 3.71 21.95 5.81 21.95H5.94C8.04 21.95 9.75 20.24 9.75 18.14V16.26C9.75 14.16 8.04 12.45 5.94 12.45Z"
        fill={props.fill}
      />
      <path
        d="M18.19 12.45H18.06C15.96 12.45 14.25 14.16 14.25 16.26V18.14C14.25 20.24 15.96 21.95 18.06 21.95H18.19C20.29 21.95 22 20.24 22 18.14V16.26C22 14.16 20.29 12.45 18.19 12.45Z"
        fill={props.fill}
      />
    </svg>
  );
};

export const QuoteUpIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 653 489"
      fill="none"
      className={props.className}
    >
      <g opacity="0.1">
        <path
          d="M220.116 232.639H92.509C94.6856 103.968 119.717 82.7522 197.805 35.9128C206.784 30.4023 209.776 18.8305 204.335 9.46261C198.893 0.370265 187.465 -2.66025 178.214 2.85026C86.2501 57.9554 54.1443 91.5689 54.1443 251.925V400.433C54.1443 447.548 91.9646 485.571 138.219 485.571H219.844C267.73 485.571 303.917 448.926 303.917 400.433V317.776C304.189 269.283 268.003 232.639 220.116 232.639Z"
          fill={props.fill}
        />
        <path
          opacity="0.4"
          d="M514.509 232.639H386.902C389.078 103.968 414.111 82.7522 492.199 35.9128C501.178 30.4023 504.171 18.8305 498.729 9.46261C493.287 0.370265 481.859 -2.66025 472.609 2.85026C380.644 57.9554 348.539 91.5689 348.539 251.925V400.433C348.539 447.548 386.359 485.571 432.613 485.571H514.238C562.125 485.571 598.311 448.926 598.311 400.433V317.776C598.583 269.283 562.395 232.639 514.509 232.639Z"
          fill={props.fill}
        />
      </g>
    </svg>
  );
};

export const SendIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 27 27"
      fill="none"
      className={props.className}
    >
      <path
        d="M19.9139 9.37717L10.4804 4.66044C4.14367 1.48656 1.54286 4.08738 4.71673 10.4241L5.67551 12.3417C5.95102 12.9037 5.95102 13.5539 5.67551 14.116L4.71673 16.0225C1.54286 22.3592 4.13265 24.96 10.4804 21.7862L19.9139 17.0694C24.1457 14.9535 24.1457 11.4931 19.9139 9.37717ZM16.3543 14.0498H10.4033C9.95143 14.0498 9.57673 13.6751 9.57673 13.2233C9.57673 12.7715 9.95143 12.3968 10.4033 12.3968H16.3543C16.8061 12.3968 17.1808 12.7715 17.1808 13.2233C17.1808 13.6751 16.8061 14.0498 16.3543 14.0498Z"
        fill={props.fill}
      />
    </svg>
  );
};

export const Facebook = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 9 13"
      fill="none"
      className={props.className}
    >
      <path
        d="M7.79995 0.5H5.99995C5.2043 0.5 4.44124 0.816071 3.87863 1.37868C3.31602 1.94129 2.99995 2.70435 2.99995 3.5V5.3H1.19995V7.7H2.99995V12.5H5.39995V7.7H7.19995L7.79995 5.3H5.39995V3.5C5.39995 3.34087 5.46316 3.18826 5.57569 3.07574C5.68821 2.96321 5.84082 2.9 5.99995 2.9H7.79995V0.5Z"
        stroke={props.stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Twitter = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 10 10"
      fill="none"
      className={props.className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.130204 0.00699811C0.130204 0.0147552 0.382438 0.383676 1.09904 1.42402C1.13477 1.47589 1.27712 1.68279 1.41538 1.88379C1.55364 2.08479 1.69426 2.28903 1.72787 2.33766C1.8143 2.4627 2.6936 3.7406 3.29342 4.61291C3.57208 5.01815 3.83072 5.39299 3.86817 5.44588L3.93625 5.54204L3.89293 5.59298C3.83655 5.65926 1.97052 7.83138 0.933462 9.0379C0.488432 9.55565 0.122541 9.98403 0.120383 9.98985C0.118108 9.99597 0.291782 10.0002 0.532994 9.99999L0.94953 9.99956L1.23423 9.66695C1.39082 9.48403 1.7402 9.07706 2.01064 8.76259C2.28107 8.44812 2.68923 7.97333 2.91765 7.70749C3.40584 7.13935 4.10937 6.32119 4.22673 6.18515L4.30915 6.08961L4.33982 6.13227C4.36447 6.16655 5.15553 7.31611 5.5232 7.85193C5.56881 7.9184 5.68836 8.09195 5.78886 8.23759C5.88936 8.38323 6.04851 8.61435 6.14253 8.75119C6.23655 8.88803 6.46769 9.22376 6.65619 9.49726L6.99892 9.99453L8.43926 9.99752C9.23145 9.99918 9.8796 9.99729 9.8796 9.99334C9.8796 9.9894 9.66901 9.68036 9.41161 9.30659C8.83684 8.47199 8.33262 7.73947 7.28028 6.2103C6.83409 5.56191 6.34788 4.85563 6.19982 4.64078C6.05177 4.42594 5.92771 4.24256 5.92415 4.2333C5.92013 4.22281 6.00583 4.11414 6.15095 3.94572C6.27923 3.79681 6.58919 3.43643 6.83972 3.14484C8.16129 1.60677 8.48955 1.22486 8.59197 1.1062C9.14494 0.465538 9.52396 0.0195064 9.52218 0.0115136C9.52034 0.0032024 8.70036 -0.00194945 8.69501 0.00631455C8.69278 0.00974511 8.35482 0.402774 8.06979 0.733405C7.77577 1.07445 6.84097 2.16204 5.89042 3.26898C5.7039 3.48619 5.54584 3.66391 5.53917 3.66391C5.5296 3.66391 5.10612 3.05577 4.51301 2.1903C4.48636 2.15139 4.38224 2.0002 4.28164 1.85431C4.18105 1.70843 3.984 1.42196 3.84375 1.21772C3.70349 1.01347 3.57018 0.819841 3.54753 0.787422C3.52486 0.755002 3.40221 0.57699 3.27497 0.391822C3.14773 0.206666 3.03399 0.0434967 3.02221 0.0292321L3.00079 0.00327307L1.5655 0.000420113C0.776081 -0.00114781 0.130204 0.001811 0.130204 0.00699811ZM2.73967 0.775633C2.96949 1.10848 4.63834 3.53317 4.98724 4.04115C5.1342 4.25512 5.30198 4.49915 5.36009 4.58344C5.64421 4.99557 6.76007 6.61622 6.84338 6.73777C6.89558 6.8139 7.09456 7.10303 7.28558 7.38027C7.47659 7.65749 7.66927 7.93737 7.71375 8.00221C7.75822 8.06705 7.98274 8.39331 8.21268 8.72723L8.63075 9.33435L7.99081 9.33755C7.37219 9.34062 7.3503 9.33998 7.33321 9.31814C7.32348 9.30572 7.24156 9.18757 7.15116 9.05559C7.06076 8.92362 6.85877 8.62997 6.70229 8.40303C6.5458 8.1761 6.20615 7.68273 5.94749 7.30667C5.02674 5.96796 4.6796 5.46347 4.46713 5.1552C4.3487 4.98338 4.02913 4.51919 3.75698 4.12367C3.48482 3.72816 3.15254 3.2454 3.01856 3.05088C2.88459 2.85637 2.57425 2.40544 2.32892 2.04883C2.08361 1.69222 1.77217 1.23993 1.63685 1.04375C1.50152 0.847568 1.38776 0.679082 1.38402 0.669344C1.37802 0.653712 1.4521 0.652003 2.01774 0.654691L2.65827 0.657744L2.73967 0.775633Z"
        fill={props.fill}
      />
    </svg>
  );
};

export const Linkedin = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 14 14"
      fill="none"
      className={props.className}
    >
      <path
        d="M9.16602 4.83301C10.028 4.83301 10.8546 5.17542 11.4641 5.78491C12.0736 6.3944 12.416 7.22105 12.416 8.08301V11.8747H10.2493V8.08301C10.2493 7.79569 10.1352 7.52014 9.93205 7.31698C9.72888 7.11381 9.45333 6.99967 9.16602 6.99967C8.8787 6.99967 8.60315 7.11381 8.39998 7.31698C8.19682 7.52014 8.08268 7.79569 8.08268 8.08301V11.8747H5.91602V8.08301C5.91602 7.22105 6.25843 6.3944 6.86792 5.78491C7.47741 5.17542 8.30406 4.83301 9.16602 4.83301Z"
        stroke={props.stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75065 5.375H1.58398V11.875H3.75065V5.375Z"
        stroke={props.stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.66732 3.74967C3.26563 3.74967 3.75065 3.26465 3.75065 2.66634C3.75065 2.06803 3.26563 1.58301 2.66732 1.58301C2.06901 1.58301 1.58398 2.06803 1.58398 2.66634C1.58398 3.26465 2.06901 3.74967 2.66732 3.74967Z"
        stroke={props.stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Instagram = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 12 12"
      fill="none"
      className={props.className}
    >
      <g clipPath="url(#clip0_22_172)">
        <path
          d="M8.5 1H3.5C2.11929 1 1 2.11929 1 3.5V8.5C1 9.88071 2.11929 11 3.5 11H8.5C9.88071 11 11 9.88071 11 8.5V3.5C11 2.11929 9.88071 1 8.5 1Z"
          stroke={props.stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.99985 5.68515C8.06156 6.10127 7.99048 6.52626 7.79673 6.89966C7.60298 7.27306 7.29643 7.57586 6.92067 7.76499C6.54491 7.95412 6.11908 8.01995 5.70375 7.95312C5.28842 7.88629 4.90473 7.69019 4.60727 7.39273C4.30981 7.09527 4.11372 6.71159 4.04689 6.29626C3.98005 5.88093 4.04589 5.4551 4.23502 5.07934C4.42415 4.70358 4.72695 4.39702 5.10035 4.20327C5.47375 4.00952 5.89873 3.93844 6.31485 4.00015C6.73932 4.06309 7.13228 4.26088 7.4357 4.5643C7.73912 4.86773 7.93691 5.26069 7.99985 5.68515Z"
          stroke={props.stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.75 3.25H8.76"
          stroke={props.stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_22_172">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CloseIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 24 24"
      fill="none"
      className={props.className}
    >
      <path
        d="M9.17 14.83L14.83 9.17004"
        stroke={props.stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.83 14.83L9.17 9.17004"
        stroke={props.stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
        stroke={props.stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EyeIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 24 24"
      fill="none"
      className={props.className}
    >
      <path
        d="M11.6849 9.49994C11.6849 10.9849 10.4849 12.1849 8.99994 12.1849C7.51494 12.1849 6.31494 10.9849 6.31494 9.49994C6.31494 8.01494 7.51494 6.81494 8.99994 6.81494C10.4849 6.81494 11.6849 8.01494 11.6849 9.49994Z"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.00001 15.7025C11.6475 15.7025 14.115 14.1425 15.8325 11.4425C16.5075 10.385 16.5075 8.60754 15.8325 7.55004C14.115 4.85004 11.6475 3.29004 9.00001 3.29004C6.35251 3.29004 3.88501 4.85004 2.1675 7.55004C1.4925 8.60754 1.4925 10.385 2.1675 11.4425C3.88501 14.1425 6.35251 15.7025 9.00001 15.7025Z"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EyeOpenIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 24 24"
      fill="none"
      className={props.className}
    >
      <path
        d="M14.53 9.47004L9.47004 14.53C8.82004 13.88 8.42004 12.99 8.42004 12C8.42004 10.02 10.02 8.42004 12 8.42004C12.99 8.42004 13.88 8.82004 14.53 9.47004Z"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.82 5.76998C16.07 4.44998 14.07 3.72998 12 3.72998C8.46997 3.72998 5.17997 5.80998 2.88997 9.40998C1.98997 10.82 1.98997 13.19 2.88997 14.6C3.67997 15.84 4.59997 16.91 5.59997 17.77"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.42004 19.5301C9.56004 20.0101 10.77 20.2701 12 20.2701C15.53 20.2701 18.82 18.1901 21.11 14.5901C22.01 13.1801 22.01 10.8101 21.11 9.40005C20.78 8.88005 20.42 8.39005 20.05 7.93005"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5099 12.7C15.2499 14.11 14.0999 15.26 12.6899 15.52"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.47 14.53L2 22"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 2L14.53 9.47"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DashboardIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 20 21"
      fill="none"
      className={props.className}
    >
      <path
        d="M13.1083 2.16663C11.7833 2.16663 11.25 2.64163 11.25 3.81663V7.59163C11.25 8.77496 11.7833 9.24163 13.1083 9.24163H16.475C17.8 9.24163 18.3333 8.76663 18.3333 7.59163V3.81663C18.3333 2.64163 17.8 2.16663 16.475 2.16663"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3333 16.975V13.6083C18.3333 12.2833 17.8 11.75 16.475 11.75H13.1083C11.7833 11.75 11.25 12.2833 11.25 13.6083V16.975C11.25 18.3 11.7833 18.8333 13.1083 18.8333H16.475C17.8 18.8333 18.3333 18.3 18.3333 16.975Z"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.75033 7.59996V3.81663C8.75033 2.64163 8.21699 2.16663 6.89199 2.16663H3.52533C2.20033 2.16663 1.66699 2.64163 1.66699 3.81663V7.59163C1.66699 8.77496 2.20033 9.24163 3.52533 9.24163H6.89199C8.21699 9.24996 8.75033 8.77496 8.75033 7.59996Z"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.89199 18.8333C8.21699 18.8333 8.75033 18.3 8.75033 16.975V13.6083C8.75033 12.2833 8.21699 11.75 6.89199 11.75H3.52533C2.20033 11.75 1.66699 12.2833 1.66699 13.6083V16.975C1.66699 18.3 2.20033 18.8333 3.52533 18.8333"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const BroadcastIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 20 20"
      fill="none"
      className={props.className}
    >
      <path
        d="M9.99967 8.33337C9.08301 8.33337 8.33301 9.08337 8.33301 10C8.33301 10.9167 9.08301 11.6667 9.99967 11.6667C10.9163 11.6667 11.6663 10.9167 11.6663 10"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.667 15C17.717 13.6083 18.3337 11.875 18.3337 10C18.3337 8.125 17.717 6.39167 16.667 5"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33366 15.0001C2.28366 13.6084 1.66699 11.8751 1.66699 10.0001C1.66699 9.82506 1.67532 9.65007 1.68365 9.4834"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33333 5C3.01667 5.425 2.73333 5.88335 2.5 6.36668"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 13C14.625 12.1667 15 11.125 15 10C15 8.87501 14.625 7.83333 14 7"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.00001 7C5.37501 7.83333 5 8.87501 5 10C5 11.125 5.37501 12.1667 6.00001 13"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AddContentIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 20 21"
      fill="none"
      className={props.className}
    >
      <path
        d="M7.9668 15.5V11.3334"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99967 13.4166H5.83301"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66699 2.16663V4.66663"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.333 2.16663V4.66663"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.44986 8.69164C2.36653 4.77498 3.74153 3.69164 6.5082 3.48331L13.1749 3.34998C15.9582 3.44998 17.3665 4.47498 17.4499 8.39164L17.5582 13.5333C17.6249 16.9666 16.8332 18.6916 12.6665 18.7833L7.66653 18.8833C3.49986 18.9666 2.6332 17.2666 2.56653 13.8416L2.5332 12.075"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ResetPasswordIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 24 24"
      fill="none"
      className={props.className}
    >
      <path
        d="M12 2C7.031 2 3 6.031 3 11H1l3.89 3.89L7 11H5c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8c-2.419 0-4.597-1.072-6.055-2.732l-1.555 1.555C8.411 19.956 10.156 21 12 21c5.523 0 10-4.477 10-10S17.523 2 12 2zm-1 9v5h2v-5h-2zm0-4v2h2V7h-2z"
        fill={props.fill || "currentColor"}
      />
    </svg>
  );
};

export const SettingsIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 20 20"
      fill="none"
      className={props.className}
    >
      <path
        d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.66699 10.7334V9.26669C1.66699 8.40003 2.37533 7.68336 3.25033 7.68336C4.75866 7.68336 5.37533 6.61669 4.61699 5.30836C4.18366 4.55836 4.44199 3.58336 5.20033 3.15003L6.64199 2.32503C7.30033 1.93336 8.15033 2.1667 8.54199 2.82503L8.63366 2.98336C9.38366 4.29169 10.617 4.29169 11.3753 2.98336L11.467 2.82503C11.8587 2.1667 12.7087 1.93336 13.367 2.32503L14.8087 3.15003C15.567 3.58336 15.8253 4.55836 15.392 5.30836C14.6337 6.61669 15.2503 7.68336 16.7587 7.68336C17.6253 7.68336 18.342 8.39169 18.342 9.26669V10.7334C18.342 11.6 17.6337 12.3167 16.7587 12.3167C15.2503 12.3167 14.6337 13.3834 15.392 14.6917C15.8253 15.45 15.567 16.4167 14.8087 16.85L13.367 17.675C12.7087 18.0667 11.8587 17.8334 11.467 17.175L11.3753 17.0167C10.6253 15.7084 9.39199 15.7084 8.63366 17.0167L8.54199 17.175C8.15033 17.8334 7.30033 18.0667 6.64199 17.675L5.20033 16.85C4.44199 16.4167 4.18366 15.4417 4.61699 14.6917C5.37533 13.3834 4.75866 12.3167 3.25033 12.3167C2.37533 12.3167 1.66699 11.6 1.66699 10.7334Z"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PauseIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 50 50"
      fill="none"
      className={props.className}
    >
      <path
        d="M24.9378 4.16663C13.4378 4.16663 4.10449 13.5 4.10449 25C4.10449 36.5 13.4378 45.8333 24.9378 45.8333C36.4378 45.8333 45.7712 36.5 45.7712 25C45.7712 13.5 36.4587 4.16663 24.9378 4.16663ZM22.3337 31.3125C22.3337 32.3125 21.917 32.7083 20.8545 32.7083H18.1462C17.0837 32.7083 16.667 32.3125 16.667 31.3125V18.6875C16.667 17.6875 17.0837 17.2916 18.1462 17.2916H20.8337C21.8962 17.2916 22.3128 17.6875 22.3128 18.6875V31.3125H22.3337ZM33.3337 31.3125C33.3337 32.3125 32.917 32.7083 31.8545 32.7083H29.167C28.1045 32.7083 27.6878 32.3125 27.6878 31.3125V18.6875C27.6878 17.6875 28.1045 17.2916 29.167 17.2916H31.8545C32.917 17.2916 33.3337 17.6875 33.3337 18.6875V31.3125Z"
        fill={props.fill}
      />
    </svg>
  );
};

export const VideoIcon = (props) => {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 122.88 111.34"
      width={props.width}
      height={props.height}
    >
      <path d="M23.59,0h75.7a23.68,23.68,0,0,1,23.59,23.59V87.75A23.56,23.56,0,0,1,116,104.41l-.22.2a23.53,23.53,0,0,1-16.44,6.73H23.59a23.53,23.53,0,0,1-16.66-6.93l-.2-.22A23.46,23.46,0,0,1,0,87.75V23.59A23.66,23.66,0,0,1,23.59,0ZM54,47.73,79.25,65.36a3.79,3.79,0,0,1,.14,6.3L54.22,89.05a3.75,3.75,0,0,1-2.4.87A3.79,3.79,0,0,1,48,86.13V50.82h0A3.77,3.77,0,0,1,54,47.73ZM7.35,26.47h14L30.41,7.35H23.59A16.29,16.29,0,0,0,7.35,23.59v2.88ZM37.05,7.35,28,26.47H53.36L62.43,7.38v0Zm32,0L59.92,26.47h24.7L93.7,7.35Zm31.32,0L91.26,26.47h24.27V23.59a16.32,16.32,0,0,0-15.2-16.21Zm15.2,26.68H7.35V87.75A16.21,16.21,0,0,0,12,99.05l.17.16A16.19,16.19,0,0,0,23.59,104h75.7a16.21,16.21,0,0,0,11.3-4.6l.16-.18a16.17,16.17,0,0,0,4.78-11.46V34.06Z" />
    </svg>
  );
};

export const GalleryIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 60 60"
      fill="none"
      className={props.className}
    >
      <path
        d="M20.0996 55H35.0996C47.5996 55 52.5996 50 52.5996 37.5V22.5C52.5996 10 47.5996 5 35.0996 5H20.0996C7.59961 5 2.59961 10 2.59961 22.5V37.5C2.59961 50 7.59961 55 20.0996 55Z"
        stroke={props.stroke}
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.0996 25C22.861 25 25.0996 22.7614 25.0996 20C25.0996 17.2386 22.861 15 20.0996 15C17.3382 15 15.0996 17.2386 15.0996 20C15.0996 22.7614 17.3382 25 20.0996 25Z"
        stroke={props.stroke}
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.27441 47.375L16.5994 39.1C18.5744 37.775 21.4244 37.925 23.1994 39.45L24.0244 40.175C25.9744 41.85 29.1244 41.85 31.0744 40.175L41.4744 31.25C43.4244 29.575 46.5744 29.575 48.5244 31.25L52.5994 34.75"
        stroke={props.stroke}
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Edit = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 14 14"
      fill="none"
      className={props.className}
    >
      <path
        d="M6.41504 1.1676H5.24837C2.33171 1.1676 1.16504 2.33427 1.16504 5.25094V8.75094C1.16504 11.6676 2.33171 12.8343 5.24837 12.8343H8.74837C11.665 12.8343 12.8317 11.6676 12.8317 8.75094V7.58427"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.35904 1.76059L4.76237 6.35726C4.58737 6.53226 4.41237 6.87643 4.37737 7.12726L4.12654 8.88309C4.0332 9.51893 4.48237 9.96226 5.1182 9.87476L6.87404 9.62393C7.11904 9.58893 7.4632 9.41393 7.64404 9.23893L12.2407 4.64226C13.034 3.84893 13.4074 2.92726 12.2407 1.76059C11.074 0.593927 10.1524 0.96726 9.35904 1.76059Z"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.69727 2.42078C9.0881 3.81494 10.1789 4.90578 11.5789 5.30244"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DeleteIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 14 14"
      fill="none"
      className={props.className}
    >
      <path
        d="M12.25 3.4882C10.3075 3.2957 8.35333 3.19653 6.405 3.19653C5.25 3.19653 4.095 3.25487 2.94 3.37153L1.75 3.4882"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.95996 2.9001L5.08829 2.13594C5.18163 1.58177 5.25163 1.1676 6.23746 1.1676H7.76579C8.75163 1.1676 8.82746 1.6051 8.91496 2.14177L9.04329 2.9001"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9956 5.33203L10.6164 11.2062C10.5522 12.122 10.4997 12.8337 8.87224 12.8337H5.12724C3.49974 12.8337 3.44724 12.122 3.38307 11.2062L3.00391 5.33203"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.02832 9.625H7.97082"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.54004 7.2926H8.45671"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MenuIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 31 18"
      fill="none"
      className={props.className}
    >
      <path
        d="M1 1H29.8"
        stroke={props.stroke}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M1 9H29.8"
        stroke={props.stroke}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M1 17H29.8"
        stroke={props.stroke}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const ViewIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 25 21"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="lucide lucide-eye"
    >
      <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
};

export const LoaderIcon = (props) => {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 100 101"
      fill="none"
      className={props.className}
    >
      <path
        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
        fill="currentColor"
      />
      <path
        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
        fill="currentFill"
      />
    </svg>
  );
};

export const CancelIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 16 16"
      fill="none"
      className={props.className}
    >
      <path
        d="M2.14663 2.8539C2.10014 2.80741 2.06327 2.75222 2.03811 2.69148C2.01295 2.63074 2 2.56564 2 2.4999C2 2.43416 2.01295 2.36906 2.03811 2.30832C2.06327 2.24758 2.10014 2.19239 2.14663 2.1459C2.19312 2.09941 2.24831 2.06254 2.30905 2.03738C2.36979 2.01222 2.43489 1.99927 2.50063 1.99927C2.56638 1.99927 2.63148 2.01222 2.69221 2.03738C2.75295 2.06254 2.80814 2.09941 2.85463 2.1459L8.00063 7.2929L13.1466 2.1459C13.1931 2.09941 13.2483 2.06254 13.309 2.03738C13.3698 2.01222 13.4349 1.99927 13.5006 1.99927C13.5664 1.99927 13.6315 2.01222 13.6922 2.03738C13.753 2.06254 13.8081 2.09941 13.8546 2.1459C13.9011 2.19239 13.938 2.24758 13.9632 2.30832C13.9883 2.36906 14.0013 2.43416 14.0013 2.4999C14.0013 2.56564 13.9883 2.63074 13.9632 2.69148C13.938 2.75222 13.9011 2.80741 13.8546 2.8539L8.70763 7.9999L13.8546 13.1459C13.9011 13.1924 13.938 13.2476 13.9632 13.3083C13.9883 13.3691 14.0013 13.4342 14.0013 13.4999C14.0013 13.5656 13.9883 13.6307 13.9632 13.6915C13.938 13.7522 13.9011 13.8074 13.8546 13.8539C13.8081 13.9004 13.753 13.9373 13.6922 13.9624C13.6315 13.9876 13.5664 14.0005 13.5006 14.0005C13.4349 14.0005 13.3698 13.9876 13.309 13.9624C13.2483 13.9373 13.1931 13.9004 13.1466 13.8539L8.00063 8.7069L2.85463 13.8539C2.80814 13.9004 2.75295 13.9373 2.69221 13.9624C2.63148 13.9876 2.56638 14.0005 2.50063 14.0005C2.43489 14.0005 2.36979 13.9876 2.30905 13.9624C2.24831 13.9373 2.19312 13.9004 2.14663 13.8539C2.10014 13.8074 2.06327 13.7522 2.03811 13.6915C2.01295 13.6307 2 13.5656 2 13.4999C2 13.4342 2.01295 13.3691 2.03811 13.3083C2.06327 13.2476 2.10014 13.1924 2.14663 13.1459L7.29363 7.9999L2.14663 2.8539Z"
        stroke={props.stroke}
        fill={props.fill}
      />
    </svg>
  );
};

export const SearchIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 20 21"
      fill="none"
      className={props.className}
    >
      <path
        d="M9.58268 2.16663C13.9577 2.16663 17.4993 5.70829 17.4993 10.0833C17.4993 14.4583 13.9577 18 9.58268 18C5.20768 18 1.66602 14.4583 1.66602 10.0833C1.66602 6.99996 3.42435 4.33329 5.99935 3.02496"
        stroke={props.stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3327 18.8333L16.666 17.1666"
        stroke={props.stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NoUserIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 150 97"
      fill="none"
      className={props.className}
    >
      <g clipPath="url(#clip0_187_1270)">
        <path
          d="M75 96.0938C116.421 96.0938 150 88.7484 150 79.6875C150 70.6266 116.421 63.2812 75 63.2812C33.5786 63.2812 0 70.6266 0 79.6875C0 88.7484 33.5786 96.0938 75 96.0938Z"
          fill="#F5F5F5"
        />
        <path
          d="M128.906 32.25L105.127 5.29219C103.985 3.45469 102.319 2.34375 100.563 2.34375H49.4367C47.6813 2.34375 46.0148 3.45469 44.8734 5.28984L21.0938 32.2523V53.9062H128.906V32.25Z"
          stroke="#D9D9D9"
        />
        <path
          d="M97.5305 39.682C97.5305 35.9203 99.8602 32.8148 102.75 32.8125H128.906V75.3211C128.906 80.2969 125.812 84.375 121.992 84.375H28.0078C24.1875 84.375 21.0938 80.2945 21.0938 75.3211V32.8125H47.25C50.1398 32.8125 52.4695 35.9133 52.4695 39.675V39.7266C52.4695 43.4883 54.825 46.5258 57.7125 46.5258H92.2875C95.175 46.5258 97.5305 43.4602 97.5305 39.6984V39.682Z"
          fill="#FAFAFA"
          stroke="#D9D9D9"
        />
      </g>
      <defs>
        <clipPath id="clip0_187_1270">
          <rect width="150" height="96.0938" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const UsersIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 20 20"
      fill="none"
      className={props.className}
    >
      <path
        d="M15.6792 3.96C16.1592 4.67 16.4392 5.52 16.4392 6.44C16.4292 8.84 14.5392 10.79 12.1592 10.87C12.0592 10.86 11.9392 10.86 11.8292 10.87C9.61922 10.8 7.82922 9.11 7.58922 6.95C7.29922 4.38 9.40922 2 11.9892 2"
        stroke={props.stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.99078 14.56C4.57078 16.18 4.57078 18.82 6.99078 20.43C9.74078 22.27 14.2508 22.27 17.0008 20.43C19.4208 18.81 19.4208 16.17 17.0008 14.56C14.2708 12.73 9.76078 12.73 6.99078 14.56Z"
        stroke={props.stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PackageIcon = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 20 20"
      fill="none"
      className={props.className}
    >
      <path
        d="M2.64258 6.19995L10.0009 10.4583L17.3092 6.22495"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 18.0083V10.45"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.99219 11.0416V12.3583C1.99219 13.5083 2.81719 14.9083 3.82552 15.4666L8.27552 17.9416C9.22552 18.4666 10.7839 18.4666 11.7339 17.9416L16.1839 15.4666C17.1922 14.9083 18.0172 13.5083 18.0172 12.3583V7.64163C18.0172 6.49163 17.1922 5.09163 16.1839 4.5333L11.7339 2.0583C10.7839 1.5333 9.22552 1.5333 8.27552 2.0583L3.82552 4.5333C2.81719 5.09163 1.99219 6.49163 1.99219 7.64163"
        stroke={props.stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Info = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 16 16"
      fill="none"
      className={props.className}
    >
      <g clipPath="url(#clip0_3_256)">
        <path
          d="M7.99998 10.6667V7.99999M7.99998 5.33333H8.00665M14.6666 7.99999C14.6666 11.6819 11.6819 14.6667 7.99998 14.6667C4.31808 14.6667 1.33331 11.6819 1.33331 7.99999C1.33331 4.3181 4.31808 1.33333 7.99998 1.33333C11.6819 1.33333 14.6666 4.3181 14.6666 7.99999Z"
          stroke={props.stroke}
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3_256">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};


export const Global = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      className={props.className}
      viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2C14.5013 4.73835 15.9228 8.29203 16 12C15.9228 15.708 14.5013 19.2616 12 22M12 2C9.49872 4.73835 8.07725 8.29203 8 12C8.07725 15.708 9.49872 19.2616 12 22M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22M2.50002 9H21.5M2.5 15H21.5"
        stroke={props.stroke}
        stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  );
};